module.exports = __webpack_public_path__ + "static/media/edit-white.7d1b7fdb.svg";